import { render, staticRenderFns } from "./BaseArticleEmbedRow.vue?vue&type=template&id=d4e814b4&"
import script from "./BaseArticleEmbedRow.vue?vue&type=script&lang=js&"
export * from "./BaseArticleEmbedRow.vue?vue&type=script&lang=js&"
import style0 from "./BaseArticleEmbedRow.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports